/**
 * Created by david on 2017/6/1.
 */
import vue from 'vue';
import CommonComponents from './common/index.js';

Object.values(CommonComponents).forEach((component) => {
    vue.component(component.name, component);
});



// WEBPACK FOOTER //
// ./src/components/index.js